export default {
  id: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  regulationAutoID: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  typeConclusion: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  reasonFrustration: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  lossType: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  reprogramSurvey: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  budget: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  engineNumber: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  },
  actionDate: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/regulation/sinisterregulation-form.js